import "./DSAManagerHeader.scss";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { env } from "../../env/env";
import { homePath } from "../../util/constants";
import ArrowLeftIcon from "../icons/ArrowLeftIcon";
import DisplayIcon from "../icons/DisplayIcon";
import { useRecoilValue } from "recoil";
import { memberState, mobileState } from "../../state/atoms";
import { Button, Drawer, Tooltip } from "antd";
import SideNavIcon from "../icons/SideNavIcon";
import { AppstoreOutlined, CalendarOutlined, MessageOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import PlaylistIcon from "../icons/PlaylistIcon";
import { ChatService } from "../../service/ChatService";
import { ScreenView } from "../pages/DSAManage";
import { isDesignSubscription, isProSubscription } from "../../service/BillingService";
import { LocationDto } from "../../generated/dashboard-client";
import { onPairNewDevice } from "../../service/DsaService";

export interface Props {
  isMarketingBannerPage: boolean;
  screens: ScreenView[];
  availableDevices: number;
  activeLocation: LocationDto;
}

export default function DSAManagerHeader({isMarketingBannerPage, screens, availableDevices, activeLocation} : Props) {
  const mobile = useRecoilValue(mobileState);
  const [isMobileMenuVisible, setMobileMenuVisible] = useState(false);
  const member = useRecoilValue(memberState);

  function closeDrawer() {
    setMobileMenuVisible(false);
  }

  function newChat() {
    ChatService.newMessage();
  }

  async function onOrderDevice() {
    if (!isProSubscription(member)) {
      if (isDesignSubscription(member)) {
        window.MHM.ProModal.switchToProWithOverview({
          memberId: member.id,
          onSuccess: () => window.location.reload()
        });
      } else {
        window.MHM.ProModal.upgrade({
          memberId: member.id,
          onSuccess: () => window.location.reload()
        });
      } 
      return;
    }

    window.MHM.ProModal.addDSA({
      memberId: `${member.ownerId}` || member.id,
      locationId: activeLocation.internalId,
      onSuccess: () => {
        window.localStorage.setItem("dsa-just-ordered-device", "true");
        window.location.reload();
      }
    });
  }
  

  return <header className={"dsa"}>
    <nav>
      <NavLink className={"logo"} to={`${homePath}/designs`}>
        <span className="arrow"><ArrowLeftIcon /></span>
        <span className={"badge"}>
          <DisplayIcon color="white" />
        </span>
        <h6>Display</h6>
      </NavLink>
      {!mobile && <>
        <ul>
          <li><NavLink to={`${env.dashboardPath}/dsa/manage`}>Manage</NavLink></li>
          <li><NavLink to={`${env.dashboardPath}/dsa/playlists`}>Playlists</NavLink></li>
          <li><NavLink to={`${env.dashboardPath}/dsa/schedules`}>Schedules</NavLink></li>
          <li><NavLink to={`${env.dashboardPath}/dsa/uploads`}>My Uploads</NavLink></li>
        </ul>
        <Button className={`order-screen ${member.enterpriseDisplayAccount ? 'with-pair' : ''}`} type="primary" onClick={() => onOrderDevice()}>Order</Button>
        {member.enterpriseDisplayAccount &&
            <Button className="pair-screen" type="primary" onClick={onPairNewDevice}>Pair New Device</Button>}
        <div className="help-btn">
          <Tooltip placement="bottom" title={"Help"}>
            <a href={"https://intercom.help/musthavemenus-289b0117ae34/en/collections/12161351-musthavemenus-display"} target="_blank" rel="noreferrer">
              <QuestionCircleOutlined/>
            </a>
          </Tooltip>
        </div>
      </>}
      {mobile && <>
        <div className={"aside-toggle"} onClick={() => setMobileMenuVisible(!isMobileMenuVisible)}>
          <SideNavIcon />
        </div>
        <Drawer
          placement="right"
          width="67vw"
          visible={isMobileMenuVisible}
          onClose={() => setMobileMenuVisible(false)}
          className="mobile-dsa-aside"
        >
          <ul>
            <li>
              <NavLink to={`${env.dashboardPath}/dsa/manage`} onClick={closeDrawer}>
                <AppstoreOutlined />
                Manage
              </NavLink>
            </li>
            <li>
              <NavLink to={`${env.dashboardPath}/dsa/playlists`} onClick={closeDrawer}>
                <PlaylistIcon />
                Playlists
              </NavLink>
            </li>
            <li>
              <NavLink to={`${env.dashboardPath}/dsa/schedules`} onClick={closeDrawer}>
                <CalendarOutlined />
                Schedules
              </NavLink>
            </li>
            <li>
              <NavLink to={`${env.dashboardPath}/dsa/uploads`} onClick={closeDrawer}>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/Upload.svg" alt="Upload"/>
                My Uploads
              </NavLink>
            </li>
            <div className={"separator"}></div>

            <li className="wide-svg">
              <a href={"https://intercom.help/musthavemenus-289b0117ae34/en/collections/12161351-musthavemenus-display"} target="_blank" rel="noreferrer" onClick={closeDrawer}>
                <QuestionCircleOutlined />
                Help Center
              </a>
            </li>
            <li>
              <button onClick={newChat}>
                <MessageOutlined />
                Chat With Us
              </button>
            </li>
          </ul>
        </Drawer>
      </>}
    </nav>
  </header>
}
